/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakCriteriaFilters } from './StreakCriteriaFilters';
import {
    StreakCriteriaFiltersFromJSON,
    StreakCriteriaFiltersFromJSONTyped,
    StreakCriteriaFiltersToJSON,
    StreakCriteriaFiltersToJSONTyped,
} from './StreakCriteriaFilters';
import type { StreakThresholdUnit } from './StreakThresholdUnit';
import {
    StreakThresholdUnitFromJSON,
    StreakThresholdUnitFromJSONTyped,
    StreakThresholdUnitToJSON,
    StreakThresholdUnitToJSONTyped,
} from './StreakThresholdUnit';
import type { StreakActivityType } from './StreakActivityType';
import {
    StreakActivityTypeFromJSON,
    StreakActivityTypeFromJSONTyped,
    StreakActivityTypeToJSON,
    StreakActivityTypeToJSONTyped,
} from './StreakActivityType';

/**
 * Defines what qualifies as progress within a streak window
 * @export
 * @interface StreakCriteria
 */
export interface StreakCriteria {
    /**
     * 
     * @type {StreakActivityType}
     * @memberof StreakCriteria
     */
    activityType: StreakActivityType;
    /**
     * How many per window (1 = just do it once)
     * @type {number}
     * @memberof StreakCriteria
     */
    threshold: number;
    /**
     * 
     * @type {StreakThresholdUnit}
     * @memberof StreakCriteria
     */
    thresholdUnit?: StreakThresholdUnit;
    /**
     * 
     * @type {StreakCriteriaFilters}
     * @memberof StreakCriteria
     */
    filters?: StreakCriteriaFilters;
}



/**
 * Check if a given object implements the StreakCriteria interface.
 */
export function instanceOfStreakCriteria(value: object): value is StreakCriteria {
    if (!('activityType' in value) || value['activityType'] === undefined) return false;
    if (!('threshold' in value) || value['threshold'] === undefined) return false;
    return true;
}

export function StreakCriteriaFromJSON(json: any): StreakCriteria {
    return StreakCriteriaFromJSONTyped(json, false);
}

export function StreakCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakCriteria {
    if (json == null) {
        return json;
    }
    return {
        
        'activityType': StreakActivityTypeFromJSON(json['activityType']),
        'threshold': json['threshold'],
        'thresholdUnit': json['thresholdUnit'] == null ? undefined : StreakThresholdUnitFromJSON(json['thresholdUnit']),
        'filters': json['filters'] == null ? undefined : StreakCriteriaFiltersFromJSON(json['filters']),
    };
}

export function StreakCriteriaToJSON(json: any): StreakCriteria {
    return StreakCriteriaToJSONTyped(json, false);
}

export function StreakCriteriaToJSONTyped(value?: StreakCriteria | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activityType': StreakActivityTypeToJSON(value['activityType']),
        'threshold': value['threshold'],
        'thresholdUnit': StreakThresholdUnitToJSON(value['thresholdUnit']),
        'filters': StreakCriteriaFiltersToJSON(value['filters']),
    };
}

